import * as React from 'react';
import * as $ from 'jquery';

import { HTMLDivRef } from '../../../../pdc-platform/src/ts/Interfaces';

// export class OverflowMixin {
//     private component = null;

//     constructor(c: React.Component<any, any>) {
//         this.component = c;
//     }

//     static getInitialState = (c: React.Component<any>) => {
//         if (c.props.disableOverflow === true) {
//             return {};
//         }

//         return {
//             containerSize: 0
//         };
//     };

//     public _componentDidMount = () => {
//         if (this.component.props.disableOverflow === true) {
//             return;
//         }

//         this.setContainerSize();
//         $(window).on('resize', this.setContainerSize);
//     };

//     public _componentWillUnmount = () => {
//         if (this.component.props.disableOverflow === true) {
//             return;
//         }

//         $(window).off('resize', this.setContainerSize);
//     };

//     public getOverflowContainerBodyStyle = (fullHeight: boolean) => {
//         const result: React.CSSProperties = { maxHeight: this.component.state.containerSize };

//         if (fullHeight) {
//             result.height = result.maxHeight;
//         }

//         return result;
//     };

//     public setContainerSize = () => {
//         if (this.component.props.disableOverflow === true) {
//             return;
//         }

//         if (this.component.state.resized === true) {
//             return;
//         }

//         var container = this.component.refs.container;
//         var header = this.component.refs.header;
//         var footer = this.component.refs.footer;

//         this.component.setState({
//             containerSize: $(container).height() - $(header).outerHeight() - $(footer).outerHeight()
//         });
//     };
// }

export function getOverflowContainerBodyStyle(
    containerHeightOnResize: number,
    containerHeight: number,
    initialHeight: number,
    setFullHeight?: boolean
) {
    const result: React.CSSProperties = {};

    if (containerHeightOnResize > 0) {
        result.maxHeight = containerHeightOnResize;
    } else if (containerHeight > 0) {
        result.maxHeight = containerHeight;
    } else if (initialHeight > 0) {
        result.maxHeight = initialHeight;
    }

    if (setFullHeight) {
        result.height = result.maxHeight;
    }

    return result;
}

export function useOverflowHook(
    disableOverflow: boolean,
    containerSizeOnResize: number,
    containerRef: HTMLDivRef,
    headerRef: HTMLDivRef,
    footerRef?: HTMLDivRef
) {
    const [containerSize, setContainerSize] = React.useState<number>(null);

    React.useEffect(() => {
        const handleOnWindowResize = () => {
            if (disableOverflow) {
                return;
            }

            if (containerSizeOnResize != null) {
                return;
            }

            const container = containerRef.current;
            const header = headerRef.current;

            let newContainerHeight = $(container).height() - $(header).outerHeight();

            if (footerRef != null) {
                newContainerHeight -= $(footerRef.current).outerHeight();
            }

            setContainerSize(newContainerHeight);
        };

        if (!disableOverflow) {
            handleOnWindowResize();
            $(window).on('resize', handleOnWindowResize);
        }

        return () => {
            if (!disableOverflow) {
                $(window).off('resize', handleOnWindowResize);
            }
        };
    }, [disableOverflow, containerSizeOnResize]);

    return containerSize;
}
